import { SnapshotRequestMsg } from '#websocket/client/proto';
import { SnapshotRequest } from './common';
export class DeleteSnapshotRequest extends SnapshotRequest {
    constructor(snapshotId, destination) {
        super({ type: SnapshotRequestMsg.RequestType.DELETE_SNAPSHOT_REQUEST, snapshotId }, destination);
    }
}
